import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  serviceList: [],
  serviceListLoading: false,
  servicePaginationData: {},
  serviceDetails: {},
  serviceDetailsLoading: false,
  updateService: false,
  modalOpen: false,
  ApiError: null,
}

const adminServiceSlice = createSlice({
  name: 'adminService',
  initialState,
  reducers: {
    // Get Service List
    getServiceListApiData: (state) => {
      state.serviceListLoading = true
    },
    getServiceListApiSuccess: (state, { payload }) => {
      state.serviceListLoading = false
      state.serviceList = payload.data
      state.servicePaginationData = {
        rowCount: payload?.total,
        page: payload?.page,
        size: payload?.size,
        nextPage: payload?.next_page,
        previousPage: payload?.previous_page,
      }
    },
    getServiceListApiFailed: (state, { payload }) => {
      state.serviceListLoading = false
      state.ApiError = payload
    },

    // Get Service Details
    getServiceDetailsApiData: (state) => {
      state.serviceDetailsLoading = true
    },
    getServiceDetailsApiSuccess: (state, { payload }) => {
      state.serviceDetailsLoading = false
      state.serviceDetails = payload.data
    },
    getServiceDetailsApiFailed: (state, { payload }) => {
      state.serviceDetailsLoading = false
      state.ApiError = payload
    },

    // Add Service
    addServiceApiData: (state) => {
      state.serviceListLoading = true
      state.updateService = false
      state.modalOpen = false
    },
    addServiceApiSuccess: (state, { payload }) => {
      state.serviceListLoading = false
      state.updateService = true
      state.modalOpen = true
      state.ApiError = payload
    },
    addServiceApiFailed: (state, { payload }) => {
      state.serviceListLoading = false
      state.ApiError = payload
    },

    // Update Service
    updateServiceApiData: (state) => {
      state.updateService = false
    },
    updateServiceApiSuccess: (state, { payload }) => {
      state.updateService = true
      state.modalOpen = true
      state.ApiError = payload
    },
    updateServiceApiFailed: (state, { payload }) => {
      state.ApiError = payload
    },

    // Delete Service
    deleteServiceApiData: (state) => {
      state.updateService = false
    },
    deleteServiceApiSuccess: (state, { payload }) => {
      state.updateService = true
      state.modalOpen = true
      state.ApiError = payload
    },
    deleteServiceApiFailed: (state, { payload }) => {
      state.ApiError = payload
    },
    // Active Inactive Service
    activeInactiveStoreServicesListApiData: (state, { payload }) => {
      state.updateService = false
      state.serviceListLoading = true
    },
    activeInactiveStoreServicesListApiSuccess: (state, { payload }) => {
      state.updateService = true
      state.serviceListLoading = false
      state.modalOpen = true
      state.ApiError = payload?.payload
    },
    activeInactiveStoreServicesListApiFailed: (state, { payload }) => {
      state.updateService = false
      state.serviceListLoading = false
    },

    // Reset Error
    resetServiceError: (state) => {
      state.ApiError = null
      state.modalOpen = false
    },
  },
})

export const {
  getServiceListApiData,
  getServiceListApiSuccess,
  getServiceListApiFailed,
  getServiceDetailsApiData,
  getServiceDetailsApiSuccess,
  getServiceDetailsApiFailed,
  addServiceApiData,
  addServiceApiSuccess,
  addServiceApiFailed,
  updateServiceApiData,
  updateServiceApiSuccess,
  updateServiceApiFailed,
  deleteServiceApiData,
  deleteServiceApiSuccess,
  deleteServiceApiFailed,
  // Active Inactive Service
  activeInactiveStoreServicesListApiData,
  activeInactiveStoreServicesListApiSuccess,
  activeInactiveStoreServicesListApiFailed,
  resetServiceError,
} = adminServiceSlice.actions

export default adminServiceSlice.reducer
